<template>
  <div>
    <div>Seleziona il nucleo</div>
    <v-select2
      @input="selectBu($event)"
      class="input-xxlarge"
      :data-allow-clear="true"
      :selectConfig="getConfig"
      :withCredentials="true"
      :multiple="true"
    />
  </div>
</template>

<script>
import vSelect2 from '../../vSelect2';
import apiConnector from '@/epersonam/apiConnector';
import { Route } from '../../../route';
import { getCookie } from '../../../plugins/userUtils';

export default {
  name: 'unitsSelectorFilter',
  props: ['buId', 'index', 'params'],
  components: {
    vSelect2,
  },
  data() {
    return {
      units: [],
    };
  },
  mounted() {},
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    business_unit_url() {
      const currentBuId = window.config.business_unit.id;
      return `${Route.BUSINESS_UNIT}/${currentBuId}.json?show_units=true`;
    },
    getConfig() {
      return {
        url: `${this.business_unit_url}`,
        headers: {
          'HTTP-X-EPERSONAM-BU-ID': window.config.business_unit.id,
        },
        processResults: this.processResults,
      };
    },
  },
  methods: {
    selectBu(bu) {
      let bu_ids = [];
      if (!bu || (Array.isArray(bu) && bu.length === 0)) {
        this.$emit('selected', { data_selected: { units_ids: [] }, index: this.index });
        return;
      }
      if (Array.isArray(bu)) {
        bu_ids = bu.map((b) => JSON.parse(b).id);
      } else {
        bu_ids = [JSON.parse(bu).id];
      }
      this.$emit('selected', { data_selected: { units_ids: bu_ids }, index: this.index });
    },
    processResults(data) {
      if (data && data.units_subtree) {
        return {
          results: data.units_subtree.map((res) => {
            return { text: res.name, id: JSON.stringify(res) };
          }),
          pagination: {
            more: data.length === 30,
          },
        };
      } else {
        return {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ml {
  margin-left: 36px;
}
</style>
